import { useContext, useEffect, useState } from 'react';
import './styles.css';
import {
	Button,
	CircularProgress,
	IconButton,
	InputAdornment,
	TextField,
	ToggleButton,
	ToggleButtonGroup,
	Tooltip
} from '@mui/material';
import Axios from 'axios'
import { contextSnack } from '../../context';
import LoginImage from '../../assets/reset.png'
import Logo from '../../assets/Logo.png'

import { loginSchema } from './validator'
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { Link, useLocation } from 'react-router-dom'
import { Buffer } from 'buffer'
import { ModalInvite } from './modal';

export default function Login() {
	const { showSnackbar, profile, setProfile } = useContext(contextSnack)

	const [email, setEmail] = useState<string>("")
	const [emailError, setEmailError] = useState<string>("")

	const [password, setPassword] = useState<string>("")
	const [passwordError, setPasswordError] = useState<string>("")
	const [showPassword, setShowPassword] = useState(false)

	const [loading, setLoading] = useState(false)

	const [redirectToLocalHost, setRedirectToLocalHost] = useState(false)

	const [openModalInvite, setOpenModalInvite] = useState(false)

	const casesErrors = {
		"email": setEmailError,
		"password": setPasswordError
	}
	const { search } = useLocation()

	useEffect(() => {
		if (search.includes("acesso")) {
			if (search.split("=")[1] === "filial") {
				setProfile("sales_counter")
			} else if (search.split("=")[1] === "matriz") {
				setProfile("pdv")
			} else {
				setRedirectToLocalHost(true)
			}
		}
	}, [])

	const execute = async () => {
		setLoading(true)
		await loginSchema.validate({
			email,
			password
		}, {
			abortEarly: false,
		}).then(async () => {
			await Axios.post(process.env.REACT_APP_AUTH_API + '/login', {
				grant_type: "client_credentials",
				profile: profile
			}, {
				headers: {
					Authorization: "Basic " + Buffer.from(email).toString('base64') + ":" + Buffer.from(password).toString('base64')
				}
			}).then((res) => {
				if (window.location.href.includes("hml")) {
					window.location.replace(process.env.REACT_APP_FRONT_ACCESS_MATRIZ_HML + "/authenticate?r=" + res.data.refresh_token)
				} else {
					window.location.replace((redirectToLocalHost ? 'http://localhost:3000' : (profile === "pdv" ? process.env.REACT_APP_FRONT_ACCESS_MATRIZ : process.env.REACT_APP_FRONT_ACCESS_FILIAL)) + "/authenticate?r=" + res.data.refresh_token)
				}
			}).catch((err) => {
				showSnackbar({
					message: err.response.data.error,
					severity: "error"
				})
			}).finally(() => {
				setLoading(false)
			})
		}).catch((err) => {
			for (let _e of err.inner) {
				casesErrors[_e.path as "email" || "password"](_e.message)
			}
		}).finally(() => setLoading(false))
	}

	return (
		<div className="container">
			<div className="image">
				<img src={LoginImage} alt="LoginImage" />
			</div>
			<div className="content">
				<div className="box">
					<div style={{
						width: "100%",
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					}}><img src={Logo} alt="Logo Ayude" /></div>
					<div className="containerText">
						<p className="wellcome">Seja bem vindo(a)!</p>
						<p className="instruction">Insira seu e-mail e senha abaixo para acessar a plataforma</p>
					</div>
					<div className="form">
						<ToggleButtonGroup
							color='primary'
							value={profile}
							onChange={(e, _profile) => {
								if (_profile) {
									setProfile(_profile)
								}
							}}
							fullWidth
							exclusive
						>

							<ToggleButton className='toggleButton' value="pdv">
								<Tooltip title={<p className="tooltip">Este novo acesso MATRIZ substitui o ANTIGO acesso PDV (pdv.trocacreditos.com.br)</p>}>
									<span>Matriz (PDV)</span>
								</Tooltip>
							</ToggleButton>


							<ToggleButton className='toggleButton' value="sales_counter">
								<Tooltip title={<p className="tooltip">Este novo acesso FILIAL substitui o ANTIGO acesso BALCÃO (smartbank.trocacreditos.com.br)</p>}>
									<span>Filial (Balcão)</span>
								</Tooltip>
							</ToggleButton>

						</ToggleButtonGroup>
						<TextField
							label={email ? "E-mail" : ""}
							placeholder="E-mail"
							sx={{
								'& ::placeholder': {
									fontSize: '1.5rem',
								}
							}}
							inputProps={{
								style: {
									fontSize: '1.5rem',
								}
							}}
							fullWidth
							value={email}
							onChange={(e) => {
								if (emailError) {
									setEmailError('')
								}
								setEmail(e.target.value)
							}}
							error={!!emailError}
							helperText={emailError}
							FormHelperTextProps={{
								style: {
									fontSize: '1.2rem'
								}
							}}
							type='email'
						/>
						<TextField
							label={password ? "Senha" : ""}
							placeholder="Senha"
							type={showPassword ? "text" : "password"}
							sx={{
								'& ::placeholder': {
									fontSize: '1.5rem',
									fontFamily: "Poppins"
								}
							}}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={() => setShowPassword(!showPassword)}>
											{showPassword ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
								style: {
									fontSize: '1.5rem',
									fontFamily: "Poppins"
								},
							}}
							fullWidth
							value={password}
							onChange={(e) => {
								if (passwordError) {
									setPasswordError('')
								}
								setPassword(e.target.value)
							}}
							error={!!passwordError}
							helperText={passwordError}
							FormHelperTextProps={{
								style: {
									fontSize: '1.2rem'
								}
							}}
						/>
					</div>
					<div className="forget">
						<Link to='/forget'>Esqueceu a senha?</Link>
					</div>
					<Button
						variant='contained'
						fullWidth
						color='primary'
						onClick={execute}
						endIcon={loading && <CircularProgress style={{ color: "#fff" }} size={24} />}
					>Entrar</Button>
				</div>
			</div>

			<ModalInvite
				open={openModalInvite}
				handleClose={() => setOpenModalInvite(false)} 
			/>
		</div>
	);
}
